import { Container, Grid } from '@material-ui/core';
import React from 'react';
import PayInstallments from './PayInstallments';
import PaymentScheduleHeader from './PaymentScheduleHeader';

const PaymentTerms = function PaymentTerms(): React.ReactElement {
  const mdWidth = 12;
  return (
    <Container maxWidth='lg'>
      <br />
      <PaymentScheduleHeader />
      <br />
      <Grid container spacing={2} justify='space-between'>
        <Grid item md={mdWidth} xs={12}>
          <PayInstallments />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PaymentTerms;
